'use client';
import styled from 'styled-components';

export const StyledTrack = styled.div`
  height: 10px;
  width: 100%;
  background-color: ${props =>
    !props.$color || props.$color === 'secondary.egg'
      ? props.theme.colors.neutral.bone
      : props.theme.colors.text.secondary};
  border-radius: 5px;
`;

export const StyledIndicator = styled.span`
  display: block;
  background-color: ${props =>
    props.theme.colors.get(props.$color, props.theme.colors.secondary.egg)};
  height: 100%;
  width: ${props => props.progress}%;
  transition: width 1s ease-in-out;
  border-radius: 5px;
`;
